import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
// import Modal from 'react-modal';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import history from '../../../other/history';
import {authorFollowersFetch, authorFollowingFetch} from '../../../actions/index';
import {ProfileThumb} from '../../../components/Common/CardComponents';
import LoaderInline from '../../../components/Common/Loader/Inline';
import cx from '../../../styles';

class AuthorFollowersFeedContainer extends Component {
    
    constructor(props) {
        super(props);
        this.state = {page: 1, eof: false};
    }

    componentDidMount() {
        this.scrollElem = this.refs.iScroll;
        //fill
        if(this.props.mode == 'followers') {
            this.props.authorFollowersFetch(this.props.userId, 1);
        } else if(this.props.mode == 'following') {
            this.props.authorFollowingFetch(this.props.userId, 1);
        }
        //add scroll handler
        if(typeof window != 'undefined') {
            this.scrollElem.addEventListener("scroll", this.bindScrollEvent);
        }
    }

    componentWillUnmount() {
        //remove scroll handler
        if(typeof window != 'undefined') {
            this.scrollElem.removeEventListener("scroll", this.bindScrollEvent);
        }
    }

    infiniteScrollHandler = () => {
        //add elems;
        const page = this.state.page + 1;
        this.setState({page});
        const prevLength = this.props.userReducer[this.props.mode] ? this.props.userReducer[this.props.mode].length : 0;
        if(this.props.mode == 'followers') {
            this.props.authorFollowersFetch(this.props.userId, page, false).then(() => {
                const nextLength = this.props.userReducer[this.props.mode] ? this.props.userReducer[this.props.mode].length : 0;
                if(prevLength === nextLength) {
                    this.setState({
                        eof: true
                    })
                }
            })
        } else if(this.props.mode == 'following') {
            this.props.authorFollowingFetch(this.props.userId, page, false).then(() => {
                const nextLength = this.props.userReducer[this.props.mode] ? this.props.userReducer[this.props.mode].length : 0;
                if(prevLength === nextLength) {
                    this.setState({
                        eof: true
                    })
                }
            })
        }
    }

    bindScrollEvent = () => {
        if (this.scrollElem.scrollTop + this.scrollElem.clientHeight >= this.scrollElem.scrollHeight) {
            if(!this.props.userReducer.isLoading && !this.state.eof) this.infiniteScrollHandler();
        }
    }

    onUserClick = (userSlug) => {
        history.push({
            pathname: userSlug
        });
        if(this.props.afterUserClick) this.props.afterUserClick();
    }

    render() {
        const {userReducer, mode} = this.props;
        return (
            <div className={cx("followers-feed-container")} ref="iScroll">
                <ul className={cx("list-warp")}>
                    {
                        userReducer[mode] &&
                        userReducer[mode].map((user, i) => {
                            return (
                                <li key={i} className={cx("flex", "flex-center")}>
                                    <ProfileThumb img={user.image} altName={`${user.fullname} profile icon`} />
                                    <h3 className={cx("pointer-click")} onClick={()=>this.onUserClick(`/${user.slug}`)}>{user.fullname}</h3>
                                </li>
                            );
                        })
                    }
                </ul>
                { userReducer.isLoading && <LoaderInline /> }
            </div>
        );
    }

}

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        authorFollowersFetch,
        authorFollowingFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthorFollowersFeedContainer);
